import { LogoutOutlined } from "@ant-design/icons";
import { Avatar, Button, Typography, notification } from "antd";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useT } from "../../../i18n";

// User footer used in the sidebar and in the mobile drawer.
export const UserInfo: React.FC<{ refetch: any }> = ({ refetch }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const t = useT();

  const user: any = queryClient.getQueryData(["/current-user"]);
  const [logoutIsLoading, setLogoutIsLoading] = useState(false);

  const logout = async () => {
    setLogoutIsLoading(true);
    try {
      Cookies.remove("accessToken");
      await refetch();
      navigate({
        pathname: location.pathname,
        search: "",
      });
      notification.success({
        message: t("common.logoutSuccess"),
        style: {
          background: "#52c41a30",
        },
      });
    } catch (error) {
      notification.error({
        message: t("common.logoutError"),
        style: {
          background: "#ff4d4f30",
        },
      });
      console.error("Wystąpił błąd podczas wylogowywania", error);
      setLogoutIsLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "10px 12px",
        borderTop: "1px solid #e8e8e6",
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <Avatar
        style={{
          background: user.icon_color,
          flexShrink: 0,
        }}
        size="small"
      >
        {user.short_name}
      </Avatar>
      <Typography.Text
        strong
        style={{
          flex: 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {user.name}
      </Typography.Text>
      <Button
        type="text"
        danger
        loading={logoutIsLoading}
        onClick={() => logout()}
        icon={<LogoutOutlined />}
        aria-label={t("common.logout")}
      />
    </div>
  );
};
